import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm, useFormsetOpenForm } from 'react-hook-form';
import { Button, Modal, Input, Select, TimePicker,Form,Space, InputNumber, Radio } from 'antd';

// import { BsPencil } from 'react-icons/bs';
import moment from 'moment'; // Import moment library
import { AddDepartment, BASE_URL, UpdateDepartment } from '../../utils/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
const { Option } = Select;

const DepartmentForm = ({ visible, onCancel, editItem,onAddOrUpdate, initialValues,setOpenForm }) => {
    const [editFormData, setEditFormData] = useState(null); // New state for editing data
    const [isEdit, setIsEdit] = useState(false);
    const [data, setData] = useState([]);
    const [apendValue , setAppendValue] = useState(false)

  const { control, handleSubmit, reset, register, setValue } = useForm({
    defaultValues: editFormData || {
      departmentName: '',
      departmentShortName: '',
      departmentDescription: '',
      subDepartments: [{ subDeptName: '', subDeptShortName: '', subDeptDescription: '' }],
    },
  }); 
  
  useEffect(() => {
    if(editItem){
        setIsEdit(true)
        setEditFormData(editItem)
      }else{
        setAppendValue(false)
        setIsEdit(false)
    }
  },[visible])
  console.log('editFormData',editItem)
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'subDepartments',
  });
  console.log('fields',fields)
  const onEditSubmit = async (formData) => {
    let isError = false;

    if (!formData.departmentName || formData.departmentName.trim() === '') {
      toast.error('Please fill in the Department Name.');
      return;
    }
  
    if (!formData.departmentShortName || formData.departmentShortName.trim() === '') {
      toast.error('Please fill in the Department Short Name.');
      return;
    }
  
  
    // Validate sub-department fields
    await formData.subDepartments.forEach((subDept, index) => {
      if (!subDept.subDeptName || subDept.subDeptName.trim() === '') {
        toast.error(`Please fill in Sub-Department Name #${index + 1}.`);
        isError = true;
        return;
      }
  
      if (!subDept.subDeptShortName || subDept.subDeptShortName.trim() === '') {
        toast.error(`Please fill in Sub-Department Short Name #${index + 1}.`);
        isError = true;
        return;
      }
  
     
    });
    if (isError) {
      return;
    }
    // Perform the update operation using the updateDepartment function
    console.log('formData',formData)
    setEditFormData(null)

        const { subDepartments, isActive,
      createdBy,
      boOwnerId,
      createdAt,departmentId,updatedAt,updateBy, ...newObject } = formData;
      const filteredNewObject = Object.fromEntries(
        Object.entries(newObject).filter(([key, value]) => value !== '')
      );
    console.log(newObject);
    console.log('editFormData.departmentId',editFormData.departmentId)
    updateDepartment(editFormData.departmentId, filteredNewObject);
    onCancel();
    setEditFormData(null)

  };
  const updateDepartment = (id , newData) =>{
    const token = localStorage.getItem('authToken');

        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${UpdateDepartment}/${id}`, {
            method: "PUT",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify(newData),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('CompanyDataa',data)
            setEditFormData(null)
            onCancel();
            reset();
          } else {
            const data = await response.json();
            console.log('CompanyDataerr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        fetchData();
  }
  useEffect(() => {
    console.log('editFormDataa',editFormData)

    reset(editFormData || {
      departmentName: '',
      departmentShortName: '',
      departmentDescription: '',
      subDepartments: [{ subDeptName: '', subDeptShortName: '', subDeptDescription: '' }],
    });
  }, [editFormData ]);
  const onSubmit = async (formData) => {
    let isError = false;

    if (!formData.departmentName || formData.departmentName.trim() === '') {
      toast.error('Please fill in the Department Name.');
      return;
    }
  
    if (!formData.departmentShortName || formData.departmentShortName.trim() === '') {
      toast.error('Please fill in the Department Short Name.');
      return;
    }
  
   
  
    // Validate sub-department fields
    await formData.subDepartments.forEach((subDept, index) => {
      if (!subDept.subDeptName || subDept.subDeptName.trim() === '') {
        toast.error(`Please fill in Sub-Department Name #${index + 1}.`);
        isError = true;
        return;
      }
  
      if (!subDept.subDeptShortName || subDept.subDeptShortName.trim() === '') {
        toast.error(`Please fill in Sub-Department Short Name #${index + 1}.`);
        isError = true;
        return;
      }
  
    });
    if (isError) {
      return;
    }
    console.log('formData',formData)
    const formattedData = {
      departments:  [{
      departmentName: formData.departmentName,
      departmentShortName: formData.departmentShortName,
      ...(formData.departmentDescription && { departmentDescription : formData.departmentDescription }),
      // departmentDescription: formData.departmentDescription,
      subDepartments: formData.subDepartments?.map((subDept) => ({
        subDeptName: subDept.subDeptName,
        ...(subDept.subDeptDescription && { subDeptDescription : subDept.subDeptDescription }),
        // subDeptDescription: subDept.subDeptDescription,
        subDeptShortName: subDept.subDeptShortName,
        subDeptId: subDept.subDeptId, // You might want to generate or assign an ID
      })),
    }]
    };
  
    console.log('formattedData',formattedData);

    const token = localStorage.getItem('authToken');

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${AddDepartment}`, {
        method: "POST",
         headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify(formattedData),
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('CompanyData',data)
        reset()
      } else {
        const data = await response.json();
        console.log('CompanyDataerr',data)
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
        
      }
    };
    await fetchData();
    const newData = [...data, formattedData];
    console.log('newdata',newData)
    setData(newData);
    reset(); // Reset the form after submission
    onCancel(); // Close the form after submission
    setEditFormData(null)
  };
  return (
    <Modal
        // title='Add Department'
        // open={openForm}
        title={editFormData ? 'Edit Department' : 'Add Department'}
        open={visible}
        className='[&_.ant-modal-title]:text-center'
        // okText={"Add Department"}
        okButtonProps={{ style: { background: 'grey' } }}
        // onOk={editFormData ? handleSubmit(onEditSubmit) : handleSubmit(onSubmit)}
        onCancel={() => {
            onCancel();
          setEditFormData(null);
          reset();
        }}
        footer={null}
      >
        <form style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="bg-[#EDF3FD] rounded-[15px] px-3 pt-3 pb-4">
     
     <div className="block">
          <div className='form-field shiftLabel mb-2'>
            <label className='mb-0 mt-1'>Department Name<span className='text-red-500'>*</span></label>
            <Controller name='departmentName'
            control={control} defaultValue={editFormData !== null ? editFormData.departmentName : ''}
            render={({ field }) => 
            <input         className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
            {...field} />} />
          </div>

          <div className='form-field shiftLabel mb-2'>
            <label className='mb-0 mt-1'>Department Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed)</label>
            <Controller
              name='departmentShortName'
              control={control}
              defaultValue={editFormData ? editFormData.departmentShortName : ''}
              render={({ field }) =>
               <input maxLength={5} className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
               {...field} />}
              
            />
          </div>

          <div className='form-field shiftLabel'>
            <label className='mb-0 mt-1'>Department Description</label>
            <Controller
              name='departmentDescription'
              control={control}
              defaultValue={editFormData ? editFormData.departmentDescription : ''}
              render={({ field }) => <input className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
              {...field} />}
            />
          </div>
          </div>
          </div>
          {!isEdit ?
          <div className='sub-dept-section'>
            {apendValue == true && ( <label className='mt-3 ml-2'><strong>Sub-Departments</strong></label>)}
            {fields.map((subDept, index) => (
              <>
              {apendValue == false && (<> ${remove(0)} </>)}
              <div key={subDept.id} className='sub-dept-field shiftLabel mb-2'>
                <div className="bg-[#EDF3FD] rounded-[15px] px-3 pt-3 pb-4">
     
     <div className="block">
                <div className='form-field mb-2'>
                  <label className='mb-0 mt-1'>Sub-Dept Name<span className='text-red-500'>*</span></label>
                  <Controller
                    name={`subDepartments[${index}].subDeptName`}
                    control={control}
                    className="h-10 bg-[#BACAD8] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-2 outline-none"

                    defaultValue=''
                    render={({ field }) => <input className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
                    {...field} />}
                  />
                </div>

                <div className='form-field mb-2'>
                  <label className='mb-0 mt-1'>Sub-Dept Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed)</label>
                  <Controller
                    name={`subDepartments[${index}].subDeptShortName`}
                    control={control}
                    defaultValue=''
                    render={({ field }) => <input maxLength={5} className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
                    {...field} />}
                  />
                </div>

                <div className='form-field'>
                  <label className='mb-0 mt-1'>Sub-Dept Description</label>
                  <Controller
                    name={`subDepartments[${index}].subDeptDescription`}
                    control={control}
                    defaultValue=''
                    render={({ field }) => <input className="h-10 bg-[#CDDEF9] rounded-full !px-5 w-full placeholder:text-[13px] border-none mt-1 outline-none"
                    {...field} />}
                  />
                </div>
                <Button type='button' className='mt-3 !border-[#00305F] text-[#00305F] hover:bg-[#00305F] hover:!text-[#fff] rounded-full py-2 px-3 h-auto !text-sm' onClick={() => remove(index)}>
                  Remove Sub-Department
                </Button>
               
                </div>
                </div>
              </div>
              </>
            ))}
          </div>
             : ""}
            {!isEdit ?
          <Button
            type='button'
            style={{alignSelf: 'center'}}
            className="!border-[#6198ED] mt-3 bg-[#6198ED] text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-5 h-auto !text-sm !outline-none"
            onClick={() =>{setAppendValue(true); append({ subDeptName: '', subDeptShortName: '', subDeptDescription: '' })}}
          >
            Add Sub-Department
          </Button>
          : ""}
          {/* <button type='submit'>Submit</button> */}
        </form>
        <div className="text-center mt-3">
                <Button
                  className="!border-[#6198ED] bg-[#6198ED]  text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-4 h-auto !text-sm !outline-none"
                onClick={editFormData ? handleSubmit(onEditSubmit) : handleSubmit(onSubmit)}
                >
                  <span className="font-sbold">+Add Department</span>
                </Button>
              </div>
      </Modal>
  );
};

export default DepartmentForm;
